import React, { useEffect, useLayoutEffect, useState } from 'react'
import { observer } from "mobx-react-lite"
import { toJS } from 'mobx';
import { makeStyles } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import Viewer from '../editor/Viewer';
import useWindowSize from '../../hooks/window-size';
import { shareDialogStore } from '../share/ShareDialog'
import { loadJson } from '../editor/editorSlice'
import { useDispatch } from 'react-redux';
import usePlayer from '../common/usePlayer';
import classes from './LoopRow.module.scss'
import { useTipsEditor } from './ctx'
import useSize from '../../hooks/size'
import clsx from 'clsx';


const useStyles = makeStyles({
  tooltip: {
    color: '#FF6500',
    backgroundColor: 'white',
    border: '1px solid #FF6500'
  },
  arrow: {
    color: '#FF6500'
  },
  button: {
    //backgroundColor: 'rgba(0, 0, 0, 0.04)',
    zIndex: '10000',
  }
});

const useBackdropStyles = () => {
  const [backdropStyles, setBackdropStyles] = useState({height: 0, width: 0})
  const bodySize = useSize('body')
  const loopsSize = useSize('#loops-list-paper')
  const actionSize = useSize('.loops-row-action')
  useEffect(() => {
    if (actionSize && loopsSize) {
      let top = document.querySelector('#loops-list-paper').offsetTop
      const ss = {
        height: loopsSize.height - (50 + 35 + 30),
        width: (40 + 8),
        borderTopWidth: top + (50 + 35),
        borderRightWidth: bodySize.width - actionSize.right + (actionSize.width - 48) / 2,
        borderLeftWidth: actionSize.left + (actionSize.width - 48) / 2,
        borderBottomWidth: bodySize.height - top - loopsSize.height + 30
      }
      //console.log('ss', ss, actionSize)
      setBackdropStyles(ss)
    }
  }, [actionSize, loopsSize])
  return backdropStyles
}

const TipsWrap = ({autoShow, children, onClick}) => {
  const styles = useStyles();
  const backdropStyles = useBackdropStyles();
  //console.log('tips=', autoShow)
  if (autoShow) {
    return <>
      <Tooltip open arrow placement="top" classes={{arrow: styles.arrow, tooltip: styles.tooltip}} onClick={onClick} title="Click on the button to view in details">{children}</Tooltip>
      <div className={classes.backdrop} style={backdropStyles}></div>
    </>
  }
  return children
}

const ViewLoop = observer(({model, first}) => {
  const [show, setShow] = useState(false)
  const styles = useStyles();
  const player = usePlayer()
  const { width, height } = useWindowSize()
  const { canShowTips, setTipsEditor } = useTipsEditor()
  const autoShow = canShowTips && first;
  const dispatch = useDispatch()
  const onShow = () => {
    if (canShowTips) {
      setTipsEditor('1')
    }
    dispatch(loadJson(toJS(model.json)))
    setShow(true)
    player.playType(null)
  }
  useLayoutEffect(() => {
    if (autoShow) {
      let top = document.querySelector('#loops-list-paper').offsetTop
      let toY = top - (height / 2)
      if (toY > 0) {
        window.scrollTo(0, toY)
      }
    }
  }, [autoShow])
  // 加载json数据
  if (width >= 768) {
    return null;
  }

  return <>
    <TipsWrap autoShow={autoShow} onClick={onShow}><IconButton onClick={onShow} className={clsx(canShowTips ? styles.button : '', 'viewer-show-icon-action')}> <ExpandCircleDownOutlinedIcon /> </IconButton></TipsWrap>
    <Viewer open={show} onClose={() => setShow(false)} id={model.id} name={model.name} url={model.url} editOwnLoop={model.isMy}
        alreadyAdd={model.alreadyAdd} backgroundImage={width > 500 ? model.packBannerImage : model.packCoverImage} 
        onAdd={model.addToMyLoop} onDownload={model.toDownload} onShare={() => shareDialogStore.showModal(model.id)} />
  </>;
})

export default ViewLoop